import gql from "graphql-tag";

export const deleteApiKey = gql`
  mutation DeleteApiKey($input: DeleteAPIKeyRequestInput) {
    DeleteApiKey(input: $input) {
      deleted
    }
  }
`;
